// src/extenders/mailer-lite-newsletter.js
var MailerLiteNewsletter = class extends HTMLElement {
  constructor() {
    super();
    const newsletterElement = this;
    const formElement = newsletterElement.querySelector("form");
    const emailInputElement = formElement.querySelector('input[type="email"]');
    const submitButtonElement = formElement.querySelector('button[type="submit"]');
    const initialButtonText = submitButtonElement.innerHTML;
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const email = emailInputElement.value;
      fetch("https://endeavour.n8p1.hostingsecure.com/webhook/92c5c6bb-48a8-4abe-9e41-55db17776a4c", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      }).then((r) => r.json()).then((data) => {
        submitButtonElement.innerHTML = data.message;
        submitButtonElement.classList.add("js-success");
        emailInputElement.value = "";
        setTimeout(() => {
          submitButtonElement.innerHTML = initialButtonText;
          submitButtonElement.classList.remove("js-success");
        }, 3e3);
      }).catch((error) => {
        console.error("Er is een fout opgetreden:", error);
      });
    });
  }
};
if (customElements.get("mailer-lite-newsletter") === void 0) {
  customElements.define("mailer-lite-newsletter", MailerLiteNewsletter);
}
